import { ReactNode } from "react";
import styles from "./MenuWrapper.module.css";

type Props = {
  children: ReactNode;
};

export function MenuWrapper({ children }: Props) {
  return <div className={styles.root}>{children}</div>;
}
